import { ElasticCobaltSortKeyEnumType } from '@mark43/cad-api';
import { createContext, ReactNode, useContext } from 'react';
import {
    ElasticSortKeyOption,
    ElasticSortTypeOption,
    SortContextType,
    useSearchSort,
} from '../../search-windows/use-search-sort';

const sortByOptions: ElasticSortKeyOption[] = [
    { label: 'Priority', value: 'BOLO_PRIORITY' },
    {
        label: 'Expiration Date',
        value: 'BOLO_EFFECTIVE_EXPIRATION_DATE',
    },
    {
        label: 'Active Date',
        value: 'BOLO_ACTIVE_DATE',
    },
];

const directionOptionsBySortKey: Partial<
    Record<ElasticCobaltSortKeyEnumType, ElasticSortTypeOption[]>
> = {
    BOLO_PRIORITY: [
        {
            label: 'Highest First',
            value: 'PRIORITY_HIGHEST_TO_LOWEST',
        },
        {
            label: 'Lowest First',
            value: 'PRIORITY_LOWEST_TO_HIGHEST',
        },
    ],
    BOLO_EFFECTIVE_EXPIRATION_DATE: [
        {
            label: 'Newest First',
            value: 'DATE_MOST_RECENT_TO_LEAST_RECENT',
        },
        {
            label: 'Oldest First',
            value: 'DATE_LEAST_RECENT_TO_MOST_RECENT',
        },
    ],
    BOLO_ACTIVE_DATE: [
        {
            label: 'Newest First',
            value: 'DATE_MOST_RECENT_TO_LEAST_RECENT',
        },
        {
            label: 'Oldest First',
            value: 'DATE_LEAST_RECENT_TO_MOST_RECENT',
        },
    ],
};

const SortContext = createContext<SortContextType | undefined>(undefined);

export function useBoloSearchSortContext() {
    const context = useContext(SortContext);
    if (context === undefined) {
        throw new Error('useBoloSearchSortContext must be used within an BoloSearchSortProvider');
    }
    return context;
}

export const BoloSearchSortProvider = ({ children }: { children: ReactNode }) => {
    const sort = useSearchSort(sortByOptions, directionOptionsBySortKey);
    return <SortContext.Provider value={sort}>{children}</SortContext.Provider>;
};
